<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}个生产范围</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增范围</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" type="danger" size="small" :disabled="multiple" v-preventReClick @click="handleDelete">
            删除
          </el-button>
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column prop="sourceType" label="生产范围分类" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.sourceType?scope.row.sourceType:'-' }}</span>
          </template> 
        </el-table-column>
        <el-table-column prop="name" label="生产范围" width="150">
        </el-table-column>
        <el-table-column prop="manageRangeName" label="对应经营范围" width="150">
        </el-table-column>
        <el-table-column prop="versionName" label="目录版本" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="categoryName" label="管理等级" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="firstCategoryNo" label="一级分类编号" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="firstCategoryName" label="一级分类名称" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="secondCategoryNo" label="二级分类编号" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.secondCategoryNo?scope.row.secondCategoryNo:'-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="secondCategoryName" label="二级分类名称" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.secondCategoryName?scope.row.secondCategoryName:'-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="operation" label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button>
            <el-button v-if="tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
            <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog :title="title + '生产范围'" :visible.sync="open" :center="true" width="500px" :before-close="cancel" :close-on-click-modal="false">
        <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
          <el-form-item label="生产范围分类" prop="sourceType">
            <el-select v-model="form.sourceType" placeholder="请选择生产范围分类" style="width: 100%" clearable multiple >
              <template v-for="item in WarehouseTypeOptions">
                <el-option :key="item.id" :label="item.name" :value="item.id"></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="生产范围" prop="name">
            <el-input disabled v-model="form.name" placeholder="系统自动生成"></el-input>
          </el-form-item>

          <el-form-item label="对应经营范围" prop="manageRangeId">
            <el-select v-model="form.manageRangeName" :disabled="!editMode" placeholder="请选择对应经营范围" filterable :filter-method="getManageRanges" style="width: 100%;" @change="manageRangeChange">
              <el-option v-for="item in STATIC_ManageRanges" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="version" label="目录版本">
            <el-radio-group v-model="form.version" :disabled="!editMode" @change="createName">
              <el-radio :label="0">旧版</el-radio>
              <el-radio :label="1">新版</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item prop="category" label="管理类别">
            <el-radio-group v-model="form.category" :disabled="!editMode" @change="createName">
              <el-radio :label="1">Ⅰ</el-radio>
              <el-radio :label="2">Ⅱ</el-radio>
              <el-radio :label="3">Ⅲ</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item prop="firstCategoryNo" label="一级分类编号">
            <el-input placeholder="请输入一级分类编号" :disabled="!editMode" @change="createName" v-model="form.firstCategoryNo"></el-input>
          </el-form-item>

          <el-form-item prop="firstCategoryName" label="一级分类名称">
            <el-input placeholder="请输入一级分类名称" :disabled="!editMode" v-model="form.firstCategoryName" @change="createName"></el-input>
          </el-form-item>

          <el-form-item prop="secondCategoryNo" label="二级分类编号">
            <el-input placeholder="请输入二级分类编号" :disabled="!editMode" @change="createName" v-model="form.secondCategoryNo"></el-input>
          </el-form-item>

          <el-form-item prop="secondCategoryName" label="二级分类名称">
            <el-input placeholder="请输入二级分类名称" :disabled="!editMode" v-model="form.secondCategoryName" @change="createName"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
          <my-button class="btn primary" type="primary" size="small" v-if="editMode" v-preventReClick @click="submit">确 定</my-button>
        </div>
      </el-dialog>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  GetProductionRanges,
  SaveProductionRange,
  GetProductionRangeById,
  RemoveProductionRanges,
} from "@/api";
import {
  WarehouseTypeOptions,
} from "@/enum";
import GetDataMixin from "@/mixin/getData-mixin.js";

export default {
  mixins: [GetDataMixin],
  data () {
    return {
      WarehouseTypeOptions:WarehouseTypeOptions,
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      editMode: false,
      // 新增、编辑的数据
      form: {},
      // 多选框数据
      ids: [],
      multipleSelection: [],
      // 列表多选
      multiple: true,
      rules: {
        sourceType: [{ required: true, message: "请选择生产范围分类", trigger: "blur" }],
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        manageRangeId: [
          { required: true, message: "请选择对应经营范围", trigger: "blur" },
        ],
        version: [
          { required: true, message: "请选择目录版本", trigger: "blur" },
        ],
        category: [
          { required: true, message: "请选择管理等级", trigger: "blur" },
        ],
        firstCategoryNo: [
          { required: true, message: "请输入一级分类编号", trigger: "blur" },
        ],
        firstCategoryName: [
          { required: true, message: "请输入一级分类名称", trigger: "blur" },
        ],
      },
    };
  },
  created () {
    this.getManageRanges("");
  },
  methods: {
    handleSelectionChange (selection) {
      this.multipleSelection = selection;
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;

      this.cancelButtonText =
        selection && selection.length > 0 && selection[0].state == 0
          ? "启用"
          : "禁用";
    },
    // 获取列表
    getData () {
      GetProductionRanges(this.query).then((res) => {
        this.tableData = res.returnData.data;
        this.total = res.returnData.totalCount;
      });
    },
    // 新建
    handleAdd () {
      this.open = true;
      this.title = "新建";
      this.resetForm();
      this.createName();
      this.editMode = true;
    },
    handleInfo (row) {
      this.resetForm();
      this.form = JSON.parse(JSON.stringify(row));
      this.open = true;
      this.editMode = false;
    },
    // 编辑
    handleUpdate (row) {
      this.resetForm();
      this.form = JSON.parse(JSON.stringify(row));
      // this.form.state = Boolean(this.form.state);
      this.open = true;
      this.title = "编辑";
      this.editMode = true;
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        // this.form.state = Number(this.form.state);
        SaveProductionRange(this.form)
          .then((res) => {
            // if (res.successful == false) {
            //   this.$my_message(res.errorMessage,"error")
            //   return;
            // }
            this.open = false;
            this.$my_message(`执行成功`, "success");
            this.getData();
          })
          .finally(() => {
          this.$store.dispatch('SetLoading',false)
        });
      });
    },
    resetForm () {
      this.form = {
        id: 0,
        sourceType:[1],
        name: "",
        version: 0,
        category: 1,
        firstCategoryNo: "",
        firstCategoryName: "",
        secondCategoryNo: "",
        secondCategoryName: "",
        orgCode :sessionStorage.getItem('orgId'),
      };
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      if (this.editMode) {
        this.$my_confirm("确认要中断当前操作吗？", "提示", {
          type: "warning",
        })
          .then(() => {
            this.open = false;
          })
          .catch(() => { });
      } else {
        this.open = false;
      }
    },
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },

    // 删除部门
    handleDelete (row) {
      const ids = row && row.id ? [row.id] : this.ids;

      this.$my_confirm("此操作将删除数据, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          return RemoveProductionRanges({ ids });
        })
        .then(() => {
          this.$my_message(`删除成功`, "success");
          this.getData();
        })
        .catch(() => { });
    },
    // 重置
    reset () {
      this.query.keyWord = "";
      this.$set(this.query, "pageIndex", 1);
      this.$set(this.query, "pageSize", 10);
      this.ids = []
      this.multipleSelection = []
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
    createName () {
      var versionName = this.form.version === 1 ? "新版" : "旧版";
      var categoryName =
        this.form.category === 1 ? "Ⅰ" : this.form.category === 2 ? "Ⅱ" : "Ⅲ";
      this.form.name = `${!versionName ? "" : versionName} ${!categoryName ? "" : categoryName
        } ${!this.form.firstCategoryNo ? "" : this.form.firstCategoryNo} ${!this.form.secondCategoryNo ? "" : this.form.secondCategoryNo
        } ${!this.form.secondCategoryName ? "" : this.form.secondCategoryName}`;
    },
    manageRangeChange (val) {
      this.form.manageRangeId = val;
    },
  },
  mounted () {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>

/deep/.el-dialog--center .el-dialog__body{
  flex: 1;
    height: 0;
    overflow-y: scroll;
}
</style>
